jQuery(function($) {

    $('#mega-menu-primary > .mega-menu-item-has-children').append('<span class="glyphicon glyphicon-triangle-bottom visible-xs-block"></span>');
    $('.glyphicon-triangle-bottom').click(function() {
        $(this).siblings('.mega-sub-menu').toggleClass('opacity-visible').slideToggle();
    });
    function overrideMegamenu() {
        $('.mega-menu-link').click(function(e) {
            $('.mega-sub-menu').css('display','none');
            $('.mega-menu-link').removeAttr('aria-haspopup');
                var menu_item_url = $(this).attr('href');
                window.open(menu_item_url, '_self');
        });
    }
    overrideMegamenu();

    $(document).ready(function() {
        $(window).on('resize', function() {
            if($(window).width() > 992) {
                $('.mega-sub-menu').attr('css','');
            }
            else {
                overrideMegamenu();
            }
        });
    });
    // Video wrapper
    function videoWrap(platform) {
        var $iframe = $('iframe[src*="'+ platform +'"]');
        if ( ! $iframe.parent().hasClass('video-wrap') ) {
            $iframe.wrap('<div class="video-wrap"></div>');
        }
    }
    videoWrap('youtube');
    videoWrap('vimeo');

/**
 * Equalise
 */
    var $equalise = $('.equalise');
    var $equalise_slides = $('.equalise-slides');

    function equalise($items) {
        if($(window).width() > 992) {
            var highest = 0;
            $items.each(function(i, el) {
                el.style.height = 'auto';
                var el_height = $(el).height();
                if(el_height > highest) {
                    highest = el_height;
                }
            });
            $items.each(function(i, el) {
                el.style.height = (highest+'px');
            });
        } else {
            $items.each(function(i, el) {
                el.style.height = 'auto';
            });
        }
    }
    // Equalise on window load
    $(document).ready( function() {
        equalise($equalise);
        $('form.submitOnChange').change(function(e) {
            $(this).submit();
        });

        if ($(window).width() > 991) {
            scrollFade();
        }
    });
    // Equalise elements on window resize
    $(window).on('resize', function() {
        overrideMegamenu();
        equalise($equalise);
    });
    if(sessionStorage["promoTriggered"] != 'yes'){
        setTimeout( function() {
            $('.promo-banner').slideDown();
        },10000);
     }
    $('.close-promo').click( function() {
        $('.promo-banner').slideUp();
        sessionStorage["promoTriggered"] = 'yes';
    })
    $(".fp-carousel-content-wrapper").slick({
        arrows:false,
        dots:true,
        autoplay: true,
        fade: true,
        autoplaySpeed: 5000
    });
    function scrollFade() {
        var pointOfRef = $('#header').height();
        var windowPos = $(window).scrollTop();

        $('.section:not(.banner-section):not(.section-fp-carousel)').each(function() {
            var thisSec = $(this);
            var secScrollTop = thisSec.position().top;

            thisSec.addClass('secFadeOut');
            if($(window).scrollTop() >= secScrollTop - 900) {
                thisSec.removeClass('secFadeOut');
            }
            $(window).on('scroll',function() {
                if($(this).scrollTop() >= secScrollTop - 800) {
                    thisSec.removeClass('secFadeOut');
                }
            })
        });
    }

    $('.carousel-block').slick();
    $('.banner-carousel').slick({
            arrows:false,
            dots:true,
            autoplay: true,
            fade: true,
            autoplaySpeed: 5000
    });

    // Smoothscrolling
    $('.smoothscroll-link').on('click', function() {
        var hashTarget = $(this).attr('href');
        var fadeOutOffset = 0;

        console.log($(window).width() < 480);

        if ($(hashTarget).hasClass('secFadeOut')) {
            fadeOutOffset = 100;
        }

        $('html, body').animate({
            scrollTop: $(hashTarget).offset().top - fadeOutOffset
        }, 2500);
    });
});